import React, { useEffect, useState } from 'react';
import Placeholder from '../../common/placeholder';
import { drawBarGraph } from './barGraph';
import { SdfSelect } from '@synerg/react-components';

export default function ApiVolumeByTime(props) {
	const { data = [], loading = false } = props;
	const [graphData, setGraphData] = useState([]);
	const [hasVolume, sethasVolume] = useState(false);
	const [selectedTimePeriod, setSelectedTimePeriod] = useState({});
	const timePeriod = [
		{ label: 'Last month', value: 1 },
		{ label: 'Last 3 months', value: 3 },
		{ label: 'Last 6 months', value: 6 },
		{ label: 'Last year', value: 12 },
		{ label: 'Last 2 years', value: 24 }
	];

	const getMonthYearInText = (year_month) => {
		const year = year_month.slice(0, 4);
		const month = year_month.slice(4);
		const date = new Date(year, month - 1);
		const year_month_text = date.toDateString().split(' ')[1] + ' ' + year;
		return year_month_text;
	};

	const aggregateGraphData = (timeInterval) => {
		const currDate = new Date();
		const selectedYear_Months = [];
		for (let i = timeInterval.value; i >= 1; i--) {
			const getDate = new Date(currDate.getFullYear(), currDate.getMonth() - i, 1);
			const monthValue = getDate.getMonth() + 1;
			const month = monthValue < 10 ? '0' + monthValue.toString() : monthValue.toString();
			const year_month = getDate.getFullYear().toString() + month;
			selectedYear_Months.push(year_month);
		}
		const finalGraphData = selectedYear_Months.map((val) => {
			const volume = data.reduce((acc, nextVal) => {
				if (val === nextVal.year_month) {
					acc += nextVal.volume;
				}
				return acc;
			}, 0);
			return {
				'year_month': getMonthYearInText(val),
				'volume': volume
			};
		});
		const hasVolume = finalGraphData.some(graphData => {
			return graphData.volume > 0;
		});
		sethasVolume(hasVolume);
		setGraphData(finalGraphData);
	}

	const onSelectTimePeriod = (timeInterval) => {
		setSelectedTimePeriod(timeInterval);
		aggregateGraphData(timeInterval);
	};

	useEffect(() => {
		if (data.length > 0) {
			aggregateGraphData(selectedTimePeriod);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data]);

	useEffect(() => {
		if (graphData.length > 0) {
			drawBarGraph(graphData);
		}
	}, [graphData]);

	return (
		<>
			<div className='flex justify-between'>
				<div>
					<div className='text-heading-05 font-bold'>API Volume</div>
					<div className='text-heading-02 font-bold'>Over time </div>
				</div>
				<SdfSelect className="w-xs"
					value={selectedTimePeriod}
					onSdfChange={({ detail }) => onSelectTimePeriod(detail)}
					items={timePeriod}
					placeholder='Select a range'
				/>
			</div>
			<div className='graph-body'>
				{loading ? <Placeholder height={400} /> : <>
					{hasVolume && <div id='volume-time-graph'></div>}
					{!hasVolume && <div className='flex min-h-md justify-center items-center'>No chart available for the selected time period</div>}
				</>}
			</div>
		</>
	)
}
